import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import LinearLoaderWithTime from "../Loaders/LinearLoaderWithTime";
import { useTranslationApp } from "../../lib/i18next";
import {
  CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES,
  CONTENT_APPROVAL_LOADING_PREPARING_REVIEW,
} from "../../i18n/keysTranslations";
import { IS_ADLE_DOMAIN } from "../../utils/constants";
import { AdleLogoLoader } from "../../assets/svg/AdleLogoLoader";

const CONTENT_APPROVAL_LOADER_TIME_MS = 20 * 1000;

const ContentApprovalLoader = ({ open = false }) => {
  const { t } = useTranslationApp();

  const labels = [
    t(CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES),
    t(CONTENT_APPROVAL_LOADING_PREPARING_REVIEW),
  ];

  return (
    <Backdrop
      sx={(theme) => ({
        color: "#000",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        zIndex: theme.zIndex.drawer + 100,
      })}
      open={open}
    >
      <Box
        sx={{
          maxWidth: 720,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {IS_ADLE_DOMAIN && <AdleLogoLoader />}
        <LinearLoaderWithTime
          time={CONTENT_APPROVAL_LOADER_TIME_MS}
          labels={labels}
          labelSide={IS_ADLE_DOMAIN ? "bottom" : "top"}
          sx={{
            "& .MuiLinearProgress-root": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#000",
              },
            },
            "& .MuiTypography-root": {
              color: "#000 !important",
            },
          }}
        />
      </Box>
    </Backdrop>
  );
};

export default ContentApprovalLoader;
